<template>
  <ErrorPage
    status-code="404"
    status-message="PAGE NOT FOUND"
  />
</template>

<script lang="ts" setup>
import ErrorPage from './components/error_page.vue';
</script>
